import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { URL } from "../url/api";

const fetchSettings = async () => {
  const response = await axios.get(`${URL}/settings`);
  return response.data;
};

export default function useSettings() {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: fetchSettings,
    staleTime: 1000 * 60 * 10,
  });

  return data;
}
